<template>
  <div>
    <div>
      <page-title without-margin>
        [Wolt] Heures d'Ouverture
      </page-title>

      <div class="text-gray-500 mb-4">
        Notre magasin sur Wolt est actuellement ouvert aux jours et heures suivants.<br>
        Veuillez noter que ces heures sont ignorées alors que le statut de la boutique <router-link class="text-luxcaddy-500 hover:underline" :to="{name: ''}">sur cette page</router-link> est « Fermé ».
      </div>

      <card>
        <template v-if="isLoading">
          <loading-svg-inline/>
        </template>

        <template v-else>
          <wolt-manage-venue-opening-hours-edit @cancel="isEditing = false" v-if="isEditing"/>

          <div v-else>
            <div v-for="(day, i) in getOpeningTimes" :key="'day-' + i" class="flex gap-x-2">
              <strong class="w-32">{{ mapDayFromEnglishToFrench(day.opening_day) }}:</strong> {{ day.opening_time }} -
              {{ day.closing_time }}
            </div>

            <div class="mt-8">
              <button-element type="warning" @click="isEditing = true">
                <fa-icon class="mr-2" icon="edit"/>
                Modifier
              </button-element>
            </div>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/components/elements/pages/PageTitle.vue";
import Card from "@/components/elements/cards/Card.vue";
import ButtonElement from "@/components/elements/buttons/ButtonElement.vue";
import {mapActions, mapGetters} from "vuex";
import LoadingSvgInline from "@/components/elements/loading/LoadingSvgInline.vue";
import WoltManageVenueOpeningHoursEdit
  from "@/components/pages/Wolt/ManageOpeningHours/Edit/WoltManageVenueOpeningHoursEdit.vue";
import {mapDayFromEnglishToFrench} from "@/helpers/languageHelper";

export default {
  name: "WoltManageVenueOpeningHours",
  components: {WoltManageVenueOpeningHoursEdit, LoadingSvgInline, ButtonElement, Card, PageTitle},
  data() {
    return {
      isEditing: false,
      isLoading: false,
    }
  },
  created() {
    this.isLoading = true;
    this.fetchVenueStatus().finally(() => this.isLoading = false);
  },
  methods: {
    mapDayFromEnglishToFrench,
    ...mapActions('wolt', [
      'fetchVenueStatus'
    ]),
  },
  computed: {
    ...mapGetters('wolt', [
      'getOpeningTimes'
    ])
  }
}
</script>